import { AxiosInstance } from 'axios';

// �}�X�^API�x�[�XURI
const resource = '/masters';

/**
 * �}�X�^API�ďo���N���X
 */
export default class MasterRepository {

    constructor(private repository: AxiosInstance) { }

    /**
     * �������i�}�X�^�擾
     * @return �������i�}�X�^���
     */
    public async getPurchaseGoods(): Promise<MasterType.PurchaseGoods[]> {
        // API�ďo��
        // TODO:#180749�̑Ή��ŁAM_PURCHASE_GOODS_R_COPMANY��_���폜�ɂ���悤�ɂȂ������A
        // �Ώۂ�API�͘_���폜���������Ă��Ȃ����߁A���i�ǉ�/�ҏW���𗘗p����ꍇ�́A�C�����K�v
        const response = await this.repository.get<MasterType.PurchaseGoods[]>(`${resource}/purchase-goods`);
        return response.data;
    }

    /**
     * �s���{�����擾
     * @return �s���{�����
     */
    public async getPrefectureInfos(): Promise<MasterType.PrefectureInfo[]> {

        // API�ďo��
        const response = await this.repository.get<MasterType.PrefectureInfo[]>(`${resource}/prefecture-info`);
        return response.data;
    }

    /**
     * ���c�z�[�����擾
     * @return ���c�z�[�����
     */
    public async getDirectHalls(): Promise<MasterType.DirectHallsInfo[]> {

        // API�ďo��
        const response = await this.repository.get<MasterType.DirectHallsInfo[]>(`${resource}/direct-halls`);
        return response.data;
    }

}